export default __webpack_public_path__ + "static/media/title.19fe5937.svg";